export default __webpack_public_path__ + "static/media/filmoteka.32b616d7.jpg";